/**
 * Sana maydonlariga QO'LDA terish uchun tahlilchi.
 *
 * Muammo (egasi, 10.09): «tug'ilgan sanasini qo'lda kiritib bo'lmayapti, kalendardan
 * tanlash kerak ekan». Mantine `DateInput` terishga ruxsat beradi, lekin standart
 * tahlilchi `valueFormat` ni EMAS, brauzerning `new Date(string)` ini ishlatadi —
 * u «22.01.2019» ni tushunmaydi (AQSh formatini kutadi) va maydon bo'sh qolaveradi.
 *
 * Shuning uchun formatlar aniq sanaladi. Nuqta, chiziqcha, slash va ajratgichsiz
 * shakl ham qabul qilinadi: klaviaturadan tez terganda odam ajratgichni tashlab
 * ketadi (`22012019`).
 */

/** Ikki xonali yil: 00–29 → 2000-yillar, 30–99 → 1900-yillar (tug'ilgan sana konteksti). */
function toliqYil(y: number): number {
  if (y >= 1000) return y;
  return y < 30 ? 2000 + y : 1900 + y;
}

/**
 * «22.01.2019», «22/01/2019», «22-01-2019», «22012019», «22.1.19» → Date.
 * Tanib bo'lmasa yoki sana mavjud bo'lmasa (31.02) — `null`.
 */
export function parseUzDate(raw: string): Date | null {
  const s = String(raw ?? '').trim();
  if (!s) return null;

  let d: number, m: number, y: number;
  const ajratgichli = s.match(/^(\d{1,2})[.\-/\s](\d{1,2})[.\-/\s](\d{2,4})$/);
  if (ajratgichli) {
    [, d, m, y] = ajratgichli.map(Number) as unknown as [unknown, number, number, number];
  } else if (/^\d{8}$/.test(s)) {
    d = +s.slice(0, 2); m = +s.slice(2, 4); y = +s.slice(4);
  } else if (/^\d{6}$/.test(s)) {
    d = +s.slice(0, 2); m = +s.slice(2, 4); y = +s.slice(4);
  } else {
    return null;
  }

  y = toliqYil(y);
  if (m < 1 || m > 12 || d < 1 || d > 31) return null;

  /* Sana MAVJUDLIGI tekshiriladi: `new Date(2019, 1, 31)` xato bermaydi, 3-martga
     siljib ketadi. Qaytgan qiymat kiritilganiga mos kelmasa — sana yaroqsiz. */
  const dt = new Date(y, m - 1, d);
  if (dt.getFullYear() !== y || dt.getMonth() !== m - 1 || dt.getDate() !== d) return null;
  return dt;
}

/** `DateInput` ga qo'yiladigan umumiy sozlama — terish ham, kalendar ham ishlaydi. */
export const uzDateProps = {
  valueFormat: 'DD.MM.YYYY',
  placeholder: 'kun.oy.yil',
  dateParser: parseUzDate,
  clearable: true,
} as const;
